// Helper to get Cookiebot consent object (handles both 'consent' and 'consents' API shapes)
const getCookiebotConsent = () => {
    // @ts-ignore
    const cookiebot = window.Cookiebot;
    return cookiebot?.consent || cookiebot?.consents;
};

// Tracks whether Cookiebot has fired any consent event. Until it does,
// we cannot know if the user is in a consent-required region, so we
// default to "allowed" to avoid silently dropping analytics for the
// majority of users (non-EU). Once Cookiebot loads and fires
// CookiebotOnAccept or CookiebotOnDecline, the actual consent values
// take over and this flag is no longer consulted.
let cookiebotHasResponded = false;

/**
 * Call when Cookiebot fires a consent event (accept or decline).
 * After this, consent decisions come from Cookiebot's actual state.
 */
export const markCookiebotResponded = () => {
    cookiebotHasResponded = true;
};

export const canUseMarketing = () => {
    const c = getCookiebotConsent();
    if (c) return c.marketing === true;
    // Cookiebot not loaded — if it hasn't responded yet, assume allowed
    return !cookiebotHasResponded;
};

export const canUseStatistics = () => {
    const c = getCookiebotConsent();
    if (c) return c.statistics === true;
    return !cookiebotHasResponded;
};